import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RequestReasonDetail from './RequestReasonDetail';
import navOperations from '../../../../../../../redux/Navigation/operations';
import userProfileSelectors from '../../../../../../../redux/UserProfile/selectors'
import permissions, { isAuthorized } from 'client/utils/Permissions';
import { formatPrice } from 'utils';
import ApprovalDispatch from 'Store/OrderManagement/Approval/ApprovalDispatch';
import { setIsItemAndOrderLevelApproval, setRequisitionApprovalData } from "Store/OrderManagement/Approval/ApprovalAction"
import { setOrderApprovalRequest, setApprovalRequestOption, setQuantityApprovalOption, setSelectedOptionsSubmit } from 'Store/Component/OrderApproval/OrderApprovalAction';

const RequestReasonDetailContainer = (props: any) => {

    const dispatch = useDispatch();
    const dispatchGetApproverActionData = ApprovalDispatch.dispatchGetApproverActionData(dispatch);    
    const dispatchNav = navOperations.dispatchNav(dispatch);
    const [requestOption, setRequestOption] = useState<any>([]);
    const [approverActionList, setApproverActionList] = useState<any>([]);
    const [disableButton, setDisableButton] = useState<any>(false);
    const [disableQuantityButton, setDisableQuantityButton] = useState<any>(false);
    const [quantityLevelComments, setQuantityLevelComments] = useState<any>([]);

    const {
        requestApproverActionData,
        approvalRequestOption,
        orderByIdValue,
        orderApprovalRequest,
        getUserDetails,
        quantityApprovalOption,
        selectedOptionsSubmit
    }: any = useSelector((state: any) => ({
        requestApproverActionData: state.ApprovalReducer.requestApproverActionData,
        approvalRequestOption: state.OrderApprovalReducer.approvalRequestOption,
        orderByIdValue: state.OrderReducer.orderByIdData,
        orderApprovalRequest: state.OrderApprovalReducer.orderApprovalRequest,
        getUserDetails: userProfileSelectors.getUserDetails(state),
        quantityApprovalOption: state.OrderApprovalReducer.quantityApprovalOption,
        selectedOptionsSubmit: state.OrderApprovalReducer.selectedOptionsSubmit
    }))

    useEffect(() => {
        dispatchGetApproverActionData("OrderLevel");
        return () => {
            dispatch(setApprovalRequestOption([]))
            dispatch(setQuantityApprovalOption([]))
            dispatch(setSelectedOptionsSubmit([]))
            dispatch(setRequisitionApprovalData([]))
            dispatch(setOrderApprovalRequest({
                 orderId: 0,
                 approverEmailId: '',
                 approverActionId: 0,
                 comment: '',
                 requestApproveVMs: []
            }))
            
        }
    }, [])

    useEffect(() => {
        if (requestApproverActionData && requestApproverActionData?.length > 0) {
            const newList: any = [];
            requestApproverActionData?.forEach((item: any) => {
                switch (item.key) {
                    case "Request More Info":
                        newList[0] = { ...item, disabled: (!isAuthorized(permissions.ApprovalsReturnToRequestor) || disableButton) };
                        break;
                    case "Approve":
                        newList[1] = { ...item, disabled: (!isAuthorized(permissions.ApprovalsApprove) || disableButton) };
                        break;
                    case "Reject":
                        newList[2] = { ...item, disabled: (!isAuthorized(permissions.ApprovalsReject) || disableButton) };
                        break;
                    default:
                        break;
                }
            })
            setApproverActionList(newList);
        }
        if (disableButton) {
            setSelectedOption("")
        }
    }, [requestApproverActionData, disableButton])

    const setRequestOptionDefault = (result: any, status: any) => {        
        let reqOptionArr = [...requestOption]
        let items: any = []
        if ((approvalRequestOption?.length != undefined && approvalRequestOption?.length != 0)) {
            items = [...approvalRequestOption];
            approvalRequestOption?.forEach((item: any, index: number) => {
                if (item.key === props.index) {
                    items?.splice(index, 1);
                }
            })
        }
        let arr: any = [];
        result[0]?.requestApprovalHistory?.forEach((i: any) => {
            arr[i] = {
                key: i,
                request: status
            }
            reqOptionArr[i] = status

        })
        dispatch(setApprovalRequestOption([...items, ...arr]))
        setRequestOption(reqOptionArr)
    }

    useEffect(() => {
        if (orderByIdValue?.orderId) {
            orderApprovalRequest.orderId = orderByIdValue?.orderId;
            orderApprovalRequest.approverEmailId = getUserDetails?.emailId;
            dispatch(setOrderApprovalRequest(orderApprovalRequest))
            const result = orderByIdValue?.approvalHistory[0]?.approvalList?.filter((approvalHistory?: any) => approvalHistory?.assignedUserEmail == getUserDetails?.emailId);
            let reqOptionArr = [...requestOption]
            let status = ''
            if(result?.length){
            if (result[0]?.status === 'Approved') {
                status = 'Approve'
                setRequestOptionDefault(result, status)
            }
            else if (result[0]?.status === 'Rejected') {
                status = 'Reject'
                setRequestOptionDefault(result, status)

            } else if (result[0]?.status === 'Pending Approval') {                
                let items: any = []
                if ((approvalRequestOption?.length != undefined && approvalRequestOption?.length != 0)) {
                    items = [...approvalRequestOption];
                    approvalRequestOption?.forEach((item: any, index: number) => {
                        if (item.key === props.index) {
                            items.splice(index, 1);
                        }
                    })
                }
                let arr: any = [];
                result[0]?.requestApprovalHistory?.forEach((x: any, i: any) => {
                    if ((x?.status == 'Returned') || (x?.status == null && result[0]?.approvedDate != '' && result[0]?.approvedDate != null)) {
                        arr[i] = {
                            key: i,
                            request: 'Request More Info'
                        }
                        reqOptionArr[i] = 'Request More Info'
                    } else if (x?.status == 'Rejected') {
                        arr[i] = {
                            key: i,
                            request: 'Reject'
                        }
                        reqOptionArr[i] = 'Reject'
                    } else if (x?.status == 'Approved') {
                        arr[i] = {
                            key: i,
                            request: 'Approve'
                        }
                        reqOptionArr[i] = 'Approve'
                    }
                    setRequestOption(reqOptionArr)
                })
                dispatch(setApprovalRequestOption([...items, ...arr]))
            }
            }
        }
    }, [JSON.stringify(orderByIdValue), props?.index, getUserDetails?.emailId])

    useEffect(() => {
        if (orderByIdValue?.orderId) {
            dispatch(setApprovalRequestOption([]))
            dispatch(setQuantityApprovalOption([]))
        }
    }, [orderByIdValue.id])

    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: ''
    });

    const hideDialog = useCallback(() => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    }, [Popupcontent])

    const popupOutlinebtnOnclick = (item: any) => {        
        if (item !== '') {
            dispatchNav(item);
            dispatch(setApprovalRequestOption([]))
            dispatch(setQuantityApprovalOption([]))
        }
        setRequestOption([...requestOption]);
        hideDialog();
    }

    const closeDialogHandler = () => {
        setRequestOption([...requestOption]);
        hideDialog();
    }

    const popupPrimarybtnOnclick = (item: any, comments: string, actionby: string, value: any) => {
        setDisableQuantityButton(true);
        if (item !== '') {
            dispatchNav(item);
            dispatch(setApprovalRequestOption([]))
            dispatch(setQuantityApprovalOption([]))
        }
        let reqOptionArr = [...requestOption]
        switch (actionby) {
            case "Approve":
                reqOptionArr[props?.index] = 'Approve'
                setRequestOption(reqOptionArr)
                break;
            case "Moreinfo":
                reqOptionArr[props?.index] = 'Request More Info'
                setRequestOption(reqOptionArr)
                break;
            case "Rejected":
                reqOptionArr[props?.index] = 'Reject'
                setRequestOption(reqOptionArr)
                break;
            default:
                break;
        }
        hideDialog();
        let arr = { 'requestId': 0, 'approverActionId': 0, 'comment': '', 'growthReasonApproveVMs': [], 'nonGrowthReasonApproveVMs': [] };
        arr['requestId'] = orderByIdValue?.requests[props.index]?.requestId
        arr['approverActionId'] = value
        arr['comment'] = comments;
        let requestItems = [...orderApprovalRequest.requestApproveVMs]
        requestItems = requestItems.filter(item => item?.requestId !== arr.requestId);
        orderApprovalRequest.requestApproveVMs = [...requestItems, arr];
        orderApprovalRequest.approverActionId = 0
        orderApprovalRequest.comment = ''
        dispatch(setIsItemAndOrderLevelApproval(null))
        let selectedVal : any = [];
        let selectedOptionsSubmitTemp = selectedOptionsSubmit?.filter((item:any) => item?.requestId !== orderByIdValue?.requests[props.index]?.requestId);
        if (props?.isBulkOrder) {
            let selectedArr = { 'requestId': 0, 'approverActionId': '' }
            selectedArr['requestId'] = orderByIdValue?.requests[props.index]?.requestId;
            selectedArr['approverActionId'] = value;
            selectedVal.push(selectedArr)
        } else {
            for(let i=0; i < orderByIdValue?.requests[props.index]?.reasons?.length; i++){
                let selectedArr = { 'requestId': 0, 'reasonId': 0, 'approverActionId': ''}
                selectedArr['requestId'] = orderByIdValue?.requests[props.index]?.requestId;
                selectedArr['reasonId'] = orderByIdValue?.requests[props.index]?.reasons[i]?.reasonId
                selectedArr['approverActionId'] = value;
                selectedVal.push(selectedArr);
            }
        }
        dispatch(setSelectedOptionsSubmit([...selectedOptionsSubmitTemp,...selectedVal]))
        dispatch(setOrderApprovalRequest(orderApprovalRequest))
    }

    useEffect(() => {
        if (requestOption?.[props.index]) {
            let items: any = []
            if ((approvalRequestOption?.length != undefined && approvalRequestOption?.length != 0)) {
                items = [...approvalRequestOption];
                approvalRequestOption?.forEach((item: any, index: number) => {
                    if (item.key === props.index) {
                        items?.splice(index, 1);
                    }
                })
            }   
            dispatch(setApprovalRequestOption([...items, {
                key: props.index,
                request: requestOption[props.index]
            }]))
        }
    }, [requestOption, props.index])

    const plannedColumn = [
        {
            key: "assetNumber",
            title: "Replaced Asset #",
            width: "80px"
        },
        {
            key: "equipmentNumber",
            title: "Unit #",
            width: "80px"
        },
        {
            key: "description",
            title: "Description",
            width: "120px"
        },
        {
            key: "year",
            title: "Year",
            width: "60px"
        },
        {
            key: "netBookedValue",
            title: "Net Booked Value",
            width: "150px"
        },
        {
            key: "mileageHourMeter",
            title: "Mileage",
            width: "150px"
        },
        {
            key: "conditionType",
            title: "Condition",
            width: "100px"
        },
        {
            key: "dispositionType",
            title: "Status",
            Cell: (row: any) => (row.rowData.dispositionType || "-"),
            width: "120px"
        },
        {
            key: "replacementAssetDisposalDate",
            title: "E1 Disposal Date",
            Cell: (row: any) => (row.rowData.replacementAssetDisposalDate || "-"),
            width: "130px"
        },
        {
            key: "approximateDisposeValue",
            title: "Anticipated Disposal Price",
            Cell: (row: any) => (row.rowData.approximateDisposeValue|| "-"),
            width: "170px",
            align: "right"

        },
        {
            key: "frsItemNumber",
            title: "FRS Item ID",
            width: "80px",
            align: "right"
        },
        {
            key: "frsItemStatus",
            title: "FRS Item Status",
            width: "100px",
            align: "right"
        },
        {
            key: "comments",
            title: "Comments",
            Cell: (row: any) => (row.rowData.comments || "-"),
            width: "120px",
            align: "right"
        }
    ]

    const businessTable = [
        {
            key: "reasonGrowthType",
            title: "New Business",
            width: "120px"
        },
        {
            key: "jobOrEmpId",
            title: "Job #",
            width: "120px"
        },
        {
            key: "jobOrEmpName",
            title: "Job Name",
            width: "120px"
        },
        {
            key: "salesAmount",
            title: "SalesAmount",
            Cell: (row: any) => (<p>${formatPrice(row.rowData.salesAmount, 2)}</p>),
            width: "120px"
        },
        {
            key: "frsItemNumber",
            title: "FRS Item ID",
            width: "80px",
            align: "right"
        },
        {
            key: "frsItemStatus",
            title: "FRS Item Status",
            width: "100px",
            align: "right"
        },
        {
            key: "comments",
            title: "Comments",
            width: "120px",
            align: "right"
        }
    ]
    const employeeTable = [
        {
            key: "reasonGrowthType",
            title: "New Employee",
            width: "120px"
        },
        {
            key: "jobOrEmpId",
            title: "Employee #",
            Cell: (row: any) => (row.rowData.jobOrEmpId || "-"),
            width: "120px"
        },
        {
            key: "jobOrEmpName",
            title: "Employee Name",
            width: "120px"
        },
        {
            key: "frsItemNumber",
            title: "FRS Item ID",
            width: "80px",
            align: "right"
        },
        {
            key: "frsItemStatus",
            title: "FRS Item Status",
            width: "100px",
            align: "right"
        },
        {
            key: "comments",
            title: "Comments",
            Cell: (row: any) => (row.rowData.comments),
            width: "120px",
            align: "right"
        }
    ]
    const comboTable = [
        {
            key: "reasonGrowthType",
            title: "New Employee / Business",
            width: "120px"
        },
        {
            key: "jobOrEmpId",
            title: "Job # / Employee #",
            Cell: (row: any) => (row.rowData.jobOrEmpId || "-"),
            width: "120px"
        },
        {
            key: "jobOrEmpName",
            title: "Job Name / Employee Name",
            width: "120px"
        },
        {
            key: "salesAmount",
            title: "SalesAmount",
            Cell: (row: any) => (row.rowData.salesAmount ? <p>${formatPrice(row.rowData.salesAmount, 2)}</p> : "-"),
            width: "120px"
        },
        {
            key: "frsItemNumber",
            title: "FRS Item ID",
            width: "80px",
            align: "right"
        },
        {
            key: "frsItemStatus",
            title: "FRS Item Status",
            width: "100px",
            align: "right"
        },
        {
            key: "comments",
            title: "Comments",
            width: "120px",
            align: "right"
        }
    ]

    const unplannedColumn = [
        {
            key: "assetNumber",
            title: "Replaced Asset #",
            width: "80px"
        },
        {
            key: "equipmentNumber",
            title: "Unit#",
            width: "80px"
        },
        {
            key: "description",
            title: "Description",
            width: "120px"
        },
        {
            key: "year",
            title: "Year",
            width: "60px"
        },
        {
            key: "netBookedValue",
            title: "Net Booked Value",
            width: "150px"
        },
        {
            key: "mileageHourMeter",
            title: "Mileage",
            width: "150px"
        },
        {
            key: "conditionType",
            title: "Condition",
            width: "100px"
        },
        {
            key: "reason",
            title: "Reason",
            width: "80px"
        },
        {
            key: "dispositionType",
            title: "Status",
            Cell: (row: any) => (row.rowData.dispositionType || "-"),
            width: "120px",
        },
        {
            key: "replacementAssetDisposalDate",
            title: "E1 Disposal Date",
            Cell: (row: any) => (row.rowData.replacementAssetDisposalDate || "-"),
            width: "130px"
        },
        {
            key: "approximateDisposeValue",
            title: "Anticipated Disposal Price",
            Cell: (row: any) => (row.rowData.approximateDisposeValue || "-"),
            width: "170px",
            align: "right"
        },
        {
            key: "frsItemNumber",
            title: "FRS Item ID",
            width: "80px",
            align: "right"
        },
        {
            key: "frsItemStatus",
            title: "FRS Item Status",
            width: "100px",
            align: "right"
        },
        {
            key: "comments",
            title: "Comments",
            Cell: (row: any) => (row.rowData.comments),
            width: "120px",
            align: "right"
        }
    ]

    useEffect(() => {
        if (props.planned != undefined) {
            for (let i = 0; i < props.planned.length; i++) {
                if (props.planned[i].netBookedValue == null) {
                    props.planned[i].netBookedValue = '-'
                }
                else if (typeof props.planned[i].netBookedValue == "number") {
                    props.planned[i].netBookedValue = `$${formatPrice(props.planned[i].netBookedValue, 2)}`
                }
                if(typeof(props.planned[i]?.approximateDisposeValue) === "number" ){
                    props.planned[i].approximateDisposeValue = '$' +  formatPrice(props.planned[i]?.approximateDisposeValue, 2)
                 }
            }
        }
    }, [props.planned])
    useEffect(() => {
        if (props.unplanned != undefined) {
            for (let i = 0; i < props.unplanned.length; i++) {
                if (props.unplanned[i].netBookedValue == null) {
                    props.unplanned[i].netBookedValue = '-'
                }
                else if (typeof props.unplanned[i].netBookedValue == "number") {
                    props.unplanned[i].netBookedValue = `$${formatPrice(props.unplanned[i].netBookedValue, 2)}`
                }
                if(typeof(props.unplanned[i]?.approximateDisposeValue) === "number"){
                    props.unplanned[i].approximateDisposeValue = '$' +  formatPrice(props.unplanned[i]?.approximateDisposeValue, 2)
                 }
            }
        }
    }, [props.unplanned])

    const [selectedOption, setSelectedOption] = useState(requestOption[props?.index]);
    const [tableVal, setTableVal] = useState("")

    useEffect(() => {
        setSelectedOption(requestOption[props?.index]);
    }, [requestOption])

    useEffect(() => {
        setTableVal("")
        if (props.growth != undefined) {
            jobOrEmp()
            if (jobVal == props.growth.length) {
                return (setTableVal("businessTable"))
            }
            else if (empVal == props.growth.length) {
                return (setTableVal("employeeTable"))
            }
            else {
                return (setTableVal("comboTable"))
            }
        }
    }, [props?.growth, orderByIdValue])

    let jobVal = 0; let empVal = 0;
    const jobOrEmp = () => {
        if (props.growth != undefined) {
            for (let i = 0; i < props.growth.length; i++) {
                if (props.growth[i].reasonGrowthType == "New Business") {
                    jobVal = jobVal + 1
                }
                else if (props.growth[i].reasonGrowthType == "New Employee") {
                    empVal = empVal + 1
                }
            }
        }
    }

    useEffect(() => {
        let items = approvalRequestOption?.length ? [...approvalRequestOption] : [];
        let approveLength = 0;
        let rejectLength = 0;
        let moreInfoLength = 0;
        if (quantityApprovalOption?.length) {
            let quantityApprovalOptionTemp = quantityApprovalOption?.filter((item: any) => item?.requestId == orderByIdValue?.requests[props.index]?.requestId);
            if (quantityApprovalOptionTemp?.length) {
                for (let i = 0; i < quantityApprovalOptionTemp?.length; i++) {
                    if (quantityApprovalOptionTemp[i]?.selectedOption == "Approve") {
                        approveLength = approveLength + 1
                    } else if (quantityApprovalOptionTemp[i]?.selectedOption == "Reject") {
                        rejectLength = rejectLength + 1
                    } else if (quantityApprovalOptionTemp[i]?.selectedOption == "Request More Info") {
                        moreInfoLength = moreInfoLength + 1
                    }
                }

                if (orderByIdValue?.requests[props.index]?.reasons?.length == approveLength) {
                    dispatch(setApprovalRequestOption([...items, {
                        key: props.index,
                        request: "Approve"
                    }]))
                    setSelectedOption("Approve")
                } else if (orderByIdValue?.requests[props.index]?.reasons?.length == rejectLength) {
                    dispatch(setApprovalRequestOption([...items, {
                        key: props.index,
                        request: "Reject"
                    }]))
                    setSelectedOption("Reject")
                } else if (orderByIdValue?.requests[props.index]?.reasons?.length == moreInfoLength) {
                    dispatch(setApprovalRequestOption([...items, {
                        key: props.index,
                        request: "Request More Info"
                    }]))
                    setSelectedOption("Request More Info")
                } else {
                    items = items?.filter((itemVal: any) => itemVal?.key != props.index);
                    dispatch(setApprovalRequestOption(items))
                    setSelectedOption("")
                }
            }
        }
    }, [quantityApprovalOption])

    const resetButtons = (e: any, index: any) => {
        e.preventDefault();
        setQuantityLevelComments([]);
        setRequestOption([])
        setDisableButton(false)
        setDisableQuantityButton(false)
        setSelectedOption("");
        let quantityApprovalOptionTemp = quantityApprovalOption?.filter((item: any) => item?.requestId != orderByIdValue?.requests[props.index]?.requestId);
        dispatch(setQuantityApprovalOption(quantityApprovalOptionTemp))
        let approvalRequestOptionTemp = approvalRequestOption?.filter((item: any) => item?.key != index);
        dispatch(setApprovalRequestOption(approvalRequestOptionTemp))
        let orderApprovalRequestTemp = orderApprovalRequest
        if(orderApprovalRequestTemp){
            for(let i = 0; i < orderApprovalRequestTemp?.requestApproveVMs?.length; i++){
                if(orderApprovalRequestTemp?.requestApproveVMs[i]?.requestId == orderByIdValue?.requests[props.index]?.requestId){
                    orderApprovalRequestTemp?.requestApproveVMs?.splice(i, 1);
                }
            }
        }
        dispatch(setOrderApprovalRequest(orderApprovalRequestTemp))
        let selectedOptionsSubmitTemp = selectedOptionsSubmit?.filter((item: any) => item?.requestId != orderByIdValue?.requests[props.index]?.requestId);
        dispatch(setSelectedOptionsSubmit(selectedOptionsSubmitTemp))
    }

    return <RequestReasonDetail
        index={props.index}
        planned={props.planned}
        growth={props.growth}
        unplanned={props.unplanned}
        approverActionList={approverActionList}
        setPopupcontent={setPopupcontent}
        Popupcontent={Popupcontent}
        requestOption={requestOption}
        hideDialog={hideDialog}
        popupOutlinebtnOnclick={popupOutlinebtnOnclick}
        popupPrimarybtnOnclick={popupPrimarybtnOnclick}
        orderByIdValue={orderByIdValue}
        itemDetail={props.itemDetail}
        setRequestOption={setRequestOption}
        closeDialogHandler={closeDialogHandler}
        plannedColumn={plannedColumn}
        unplannedColumn={unplannedColumn}
        businessTable={businessTable}
        employeeTable={employeeTable}
        comboTable={comboTable}
        selectedOption={selectedOption}
        tableVal={tableVal}
        viewType={props.viewType}
        setDisableButton={setDisableButton}
        disableQuantityButton={disableQuantityButton}
        resetButtons={resetButtons}
        disableButton = {disableButton}
        setQuantityLevelComments={setQuantityLevelComments}
        quantityLevelComments={quantityLevelComments}
        isBulkOrder={props?.isBulkOrder}
    />
}

export default RequestReasonDetailContainer;